import {defineCustomElement} from "vue";
import CostComparison from "@/Components/CostComparison.ce.vue";

// Web Component registrieren
const CostComparisonElement = defineCustomElement(CostComparison);

// Globale Registrierung als Custom Element
customElements.define("cost-comparison", CostComparisonElement);
